const breadcrumbStorageKey = 'wittyEleganceProductBreadcrumbOrigin';
const breadcrumbOriginLifetime = 30 * 60 * 1000;

function saveProductOrigin(link) {
  try {
    const destination = new URL(link.href, window.location.origin);
    const title = link.dataset.breadcrumbOriginTitle;
    if (!title) return;

    sessionStorage.setItem(
      breadcrumbStorageKey,
      JSON.stringify({
        productPath: destination.pathname,
        backUrl: `${window.location.pathname}${window.location.search}${window.location.hash}`,
        title,
        expiresAt: Date.now() + breadcrumbOriginLifetime,
      })
    );
  } catch {
    return;
  }
}

function applyProductOrigin() {
  let origin;
  try {
    origin = JSON.parse(sessionStorage.getItem(breadcrumbStorageKey));
  } catch {
    sessionStorage.removeItem(breadcrumbStorageKey);
    return;
  }

  if (!origin || origin.expiresAt < Date.now()) {
    sessionStorage.removeItem(breadcrumbStorageKey);
    return;
  }

  document.querySelectorAll('[data-breadcrumb-context]').forEach((breadcrumb) => {
    if (breadcrumb.dataset.productPath !== origin.productPath) return;

    const originLink = breadcrumb.querySelector('.breadcrumbs__origin-link');
    const mobileBack = breadcrumb.querySelector('.breadcrumbs__mobile-back');
    if (originLink) {
      originLink.href = origin.backUrl;
      originLink.textContent = origin.title;
    }
    if (mobileBack) {
      mobileBack.href = origin.backUrl;
      const backLabel = mobileBack.querySelector('[data-breadcrumb-back-label]');
      if (backLabel) backLabel.textContent = `Back to ${origin.title}`;
    }
  });
}

document.addEventListener(
  'click',
  (event) => {
    const eventTarget = event.target instanceof Element ? event.target : event.target?.parentElement;
    const clickedLink = eventTarget?.closest('a[href]');
    if (!clickedLink) return;

    // Product titles can be separate links layered above the card's primary link.
    // Read the origin from either the clicked link or the card's annotated link.
    const productCard = clickedLink.closest('product-card, product-card-link, product-component, .resource-card');
    const originLink = clickedLink.matches('[data-breadcrumb-product-origin]')
      ? clickedLink
      : productCard?.querySelector('a[data-breadcrumb-product-origin]');

    if (originLink) saveProductOrigin(originLink);
  },
  true
);

applyProductOrigin();

document.addEventListener('shopify:section:load', applyProductOrigin);
window.addEventListener('pageshow', applyProductOrigin);
